function escapeHtml() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function formatListedDate(ms) {
  var n = Number(ms);
  if (!n) {
    return '—';
  }
  var date = new Date(n);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }
  return date.toLocaleDateString();
}
function shortKey() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var value = String(key || '').trim();
  if (!value) {
    return 'anon';
  }
  if (value.length <= 18) {
    return value;
  }
  return "".concat(value.slice(0, 8), "\u2026").concat(value.slice(-8));
}
function riskLabel() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (value === 'Low' || value === 'Medium' || value === 'High' || value === 'Dangerous') {
    return value;
  }
  return 'Unclassified';
}
function sortAttrs(column, sort, direction) {
  var on = column === sort;
  var aria = on ? direction === 'asc' ? 'ascending' : 'descending' : 'none';
  var cls = on ? ' is-sorted' : '';
  return "class=\"is-sortable".concat(cls, "\" data-sort=\"").concat(column, "\" aria-sort=\"").concat(aria, "\"");
}
function table() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$listings = _ref.listings,
    listings = _ref$listings === void 0 ? [] : _ref$listings,
    _ref$sort = _ref.sort,
    sort = _ref$sort === void 0 ? 'created_at' : _ref$sort,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'desc' : _ref$direction;
  var dir = String(direction || '').toLowerCase() === 'asc' ? 'asc' : 'desc';
  var rows = (listings || []).map(function (summary) {
    var _summary$returnTitle, _summary$returnPrice;
    var signature = escapeHtml(summary.listing_signature || '');
    var seller = String(summary.seller || '').trim();
    var sellerLabel = escapeHtml(shortKey(seller));
    var sellerFull = escapeHtml(seller);
    var title = escapeHtml(((_summary$returnTitle = summary.returnTitle) === null || _summary$returnTitle === void 0 ? void 0 : _summary$returnTitle.call(summary)) || summary.title || 'Untitled Item');
    var price = escapeHtml(((_summary$returnPrice = summary.returnPrice) === null || _summary$returnPrice === void 0 ? void 0 : _summary$returnPrice.call(summary)) || '—');
    var listed = escapeHtml(formatListedDate(summary.created_at));
    var risk = riskLabel(summary.risk);
    var riskAttr = escapeHtml(risk);
    return "\n          <tr data-signature=\"".concat(signature, "\">\n            <td class=\"select-cell\">\n              <input type=\"checkbox\" data-select-row aria-label=\"Select listing\" />\n            </td>\n            <td class=\"user-cell\">\n              <button type=\"button\" class=\"user-key\" data-action=\"message-seller\" data-public-key=\"").concat(sellerFull, "\" title=\"").concat(sellerFull, "\">").concat(sellerLabel, "</button>\n            </td>\n            <td>").concat(title, "</td>\n            <td>").concat(price, "</td>\n            <td class=\"listed-cell\">").concat(listed, "</td>\n            <td class=\"view-cell\">\n              <a href=\"#\" class=\"view-link\" data-action=\"preview-listing\">listing</a>\n              <a href=\"#\" class=\"view-link\" data-action=\"inspect-listing\">inspect</a>\n            </td>\n            <td class=\"risk-cell\">\n              <span class=\"risk-badge\" data-risk=\"").concat(riskAttr, "\">").concat(riskAttr, "</span>\n            </td>\n          </tr>");
  }).join('');
  return "\n    <div class=\"listings-table-wrap\">\n      <table class=\"listings-table moderation-table\">\n        <caption>Listings awaiting moderation</caption>\n        <thead>\n          <tr>\n            <th scope=\"col\" class=\"select-cell\">\n              <input type=\"checkbox\" data-select-all aria-label=\"Select all visible listings\" />\n            </th>\n            <th scope=\"col\" ".concat(sortAttrs('seller', sort, dir), ">User</th>\n            <th scope=\"col\" ").concat(sortAttrs('title', sort, dir), ">Title</th>\n            <th scope=\"col\" ").concat(sortAttrs('price', sort, dir), ">Price</th>\n            <th scope=\"col\" ").concat(sortAttrs('created_at', sort, dir), ">Listed</th>\n            <th scope=\"col\">View</th>\n            <th scope=\"col\" ").concat(sortAttrs('risk', sort, dir), ">Risk</th>\n          </tr>\n        </thead>\n        <tbody>").concat(rows, "\n        </tbody>\n      </table>\n    </div>\n  ");
}
module.exports = function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref2$loading = _ref2.loading,
    loading = _ref2$loading === void 0 ? true : _ref2$loading,
    _ref2$denied = _ref2.denied,
    denied = _ref2$denied === void 0 ? false : _ref2$denied;
  if (denied) {
    return "\n    <section class=\"catalog storefront-catalog moderation-page\" data-moderation-root>\n      <p class=\"body\" role=\"status\">You are not authorized to moderate Store listings.</p>\n    </section>\n  ";
  }
  var status = loading ? "<div class=\"storefront-status\" data-storefront-status role=\"status\" aria-live=\"polite\">\n        <div class=\"saito-spinner\" aria-hidden=\"true\"></div>\n        <p>Loading listings\u2026</p>\n      </div>" : "<div class=\"storefront-status\" data-storefront-status hidden></div>";
  return "\n    <section class=\"catalog storefront-catalog moderation-page\" data-moderation-root>\n      ".concat(status, "\n      <div class=\"moderation-toolbar\">\n        <button type=\"button\" class=\"saito-button-primary\" data-action=\"approve\" disabled>Approve</button>\n        <button type=\"button\" class=\"saito-button-secondary\" data-action=\"reject\" disabled>Reject</button>\n      </div>\n      <div data-listings-table></div>\n      <div class=\"catalog-footer\" data-catalog-footer hidden></div>\n    </section>\n  ");
};
module.exports.table = table;
module.exports.escapeHtml = escapeHtml;